import "./userComponents.css"


const PersonalInfoSection = ({ personalInfo, iconMap }) => {
  return (
    <div className="pl-8">
      {/* <div className="font-semibold text-lg">Rutuja</div>
      <div className="text-sm text-gray-500">Delivery Partner</div> */}

      <div className="font-[500] text-base mt-3">Personal Information</div>
      <div className="overflow-y-auto pr-2 hide-scrollbar h-auto xl:h-[calc(100vh-440px)] pb-2">
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-2 gap-x-4 gap-y-4">
          {Object.entries(personalInfo).map(([label, value], idx) => {
            const IconComponent = iconMap[label];

            return (
              <div key={idx} className="flex">
                <div className="mt-2">
                  <div className="flex justify-center items-center h-[30px] w-[30px] rounded-full bg-[#F3F3F3]">
                    {IconComponent && <IconComponent style={{ height: 16, width: 16 }} />}
                  </div>
                </div>
                <div className="ml-3">
                  <div className="text-[13px]">{label}</div>
                  <div className="font-semibold text-[14px]">{value}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default PersonalInfoSection
